export default __webpack_public_path__ + "static/portfolio-about-cd1d977e352f964b7913ea28d8c96e05.jpg";